<template lang="html">
  <b-navbar type="faded" class="showLargeScreenOnly d-flex justify-content-between p-4 h-120px">
    <div class="d-flex">
      <b-navbar-brand href="#" class="py-4">
        <img :src="imgVarsLong" @click="loadAccueil" alt="DealPrudence" class="heritage-web-header largescreen" style="margin-top:0.2rem;width:400px">
        <!--<img :src="imgVarsShort" @click="loadAccueil" alt="DealPrudence" class="heritage-web-header middlescreen">-->
      </b-navbar-brand>
    </div>
    <div class="d-flex">
      <div class="d-flex mr-4">
        <b-navbar-nav class="m-auto text-light" fill :key="resetMenu">
        <span v-if="!isDisabledItem(item)" :disabled="!item.enabled" v-for="(item, id) in menu">
          <div v-if="item.list" @mouseover="autoDropdown(true, 'dropdown' + id)" @mouseleave="autoDropdown(false, 'dropdown' + id)">
            <b-nav-item-dropdown v-if="hasOneRight(item.list)" :ref="'dropdown' + id" :text="$t(item.title)"
                                 toggle-class="text-menu" class="h5 font-weight-bold dropDownInnerWebHeader p-1 p-xl-2 mt-3"
                                 :class="{selectedMenuItemWebHeader: item.list.some((e) => selectedMenu === e.link)}">
              <div slot="button-content" style="display: inline-block">
                <span>{{ $t(item.title) }}</span>
                <div class="border-bottom pt-2 border-light position-absolute" style="width: calc(100% - 1rem)" v-if="item.list.some((e) => selectedMenu === e.link)"></div>
              </div>
              <b-dropdown-item v-for="subitem in item.list"
                               v-if="!isDisabledItem(subitem) && canShowSpecific(subitem)"
                               :disabled="!subitem.enabled"
                               class="dropdown-item-web-header mb-1"
                               :class="{selectedMenuItemWebHeader: selectedMenu === subitem.link, subItemMenuWebHeader: subitem.id === 0, subItemTextWebHeader: subitem.id !== 0}"
                               :key="subitem.id" @click="getClicked(subitem)">
                <span class="pb-1" :class="subitem.link === selectedMenu ? 'border-bottom border-success' : ''">{{ $t(subitem.title) }}</span>
                <span v-if="!subitem.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
          <b-nav-item :disabled="!item.enabled" v-else-if="!isDisabledItem(item)"
                      class="h5 text-menu subItemTextOnlyWebHeader p-1 p-xl-2 mt-3 font-weight-bold"
                      :class="{selectedMenuItemWebHeader: selectedMenu === item.link}"
                      :link-classes="{borderSuccessMenu: selectedMenu === item.link}"
                      @click="getClicked(item)" >
            {{ $t(item.title) }}
            <span v-if="!item.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
            <!--DRO 03/07/2023 : Commenté l'attribut 'style'. Enlever les classes et remettre le style si nécessaire-->
            <div class="border-bottom pt-2 border-light position-absolute" style="width: calc(100% - 1rem)" v-if="item.link === selectedMenu"></div>
          </b-nav-item>
        </span>
        </b-navbar-nav>
      </div>
      <div class="d-flex align-items-center pl-1 border border-light shadow" style="border-radius: 20px">
        <b-navbar-nav fill class="px-0 px-lg-3 border-light" :class="{'border-right': !flagTOOLBOX}">
          <div @mouseover="autoDropdown(true, 'log')" @mouseleave="autoDropdown(false, 'log')">
            <b-nav-item-dropdown v-if="this.$engine.user && this.$engine.user.userAccountId !== 1" ref="log" class="logOut" toggle-class="d-flex align-items-center" right variant="link">
              <template v-slot:button-content>
                <img class="navbarProfileImage mr-2" :src="imgProfil" alt=""/>
                <div class="d-flex flex-column align-items-start">
                  <span class="d-none d-xl-inline mr-2 mb-0 text-menu text-light profile-menu font-weight-bold"> {{ companyName }} </span>
                  <span class="d-none d-xl-inline mr-2 mb-0 text-menu text-light profile-menu"> {{ userName }} </span>
                </div>
              </template>
              <b-dropdown-item @click="goToLink('/profile/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.my_prfl') }}</b-dropdown-item>
              <b-dropdown-item v-if="hasMultipleAccounts()" @click="activateModalProfile" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.swtch_prfl') }}</b-dropdown-item>
              <b-dropdown-item v-if="$engine.rights.rightIs('settings_consult',true)" @click="goToLink('/settings/application/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('Webheader.settings') }}</b-dropdown-item>
              <b-dropdown-item @click="logout" class="subItemTextWebHeader dropdown-item-web-header">{{ this.$t('leftPanelTitle.lgout') }}</b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </b-navbar-nav>



        <!--<b-navbar-nav fill class="mx-1 my-2 m-lg-2">
          <b-button variant="primary" class="px-2 px-lg-4 d-none-max-849px text-nowrap" @click="logout">
            <span class="d-none-max-1459px"> {{ $t('leftPanelTitle.lgout') }} </span>
            <i class="d-none-min-1460px fa fa-power-off fs-14px"></i>
          </b-button>
        </b-navbar-nav>-->

        <b-navbar-nav fill class="mx-0 mx-lg-3" v-if="!flagTOOLBOX">
          <b-dropdown right toggle-class="border-0 p-0 bg-none m-md-2 text-dark bg-none-first-child" v-model="language">
            <template slot="button-content">
              <img class="flag-nav" v-if="language === 'FR'" :src="logoFlagFR" alt=""/>
              <img class="flag-nav" v-if="language === 'EN'" :src="logoFlagEN" alt=""/>
              <img class="flag-nav" v-if="language === 'GB'" :src="logoFlagEN" alt=""/>
              <img class="flag-nav" v-if="language === 'DE'" :src="logoFlagDE" alt=""/>
              <img class="flag-nav" v-if="language === 'IT'" :src="logoFlagIT" alt=""/>
              <img class="flag-nav" v-if="language === 'ES'" :src="logoFlagES" alt=""/>
              <img class="flag-nav" v-if="language === 'PT'" :src="logoFlagPT" alt=""/><span class="text-light">{{ labelLanguage }}</span>
            </template>
            <b-dropdown-item v-for="option in options" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
              <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt=""/>
              <img class="flag-nav" v-else-if="option.value === 'GB'" :src="logoFlagEN" alt=""/>
              <img class="flag-nav" v-else-if="option.value === 'DE'" :src="logoFlagDE" alt=""/>
              <img class="flag-nav" v-else-if="option.value === 'IT'" :src="logoFlagIT" alt=""/>
              <img class="flag-nav" v-else-if="option.value === 'ES'" :src="logoFlagES" alt=""/>
              <img class="flag-nav" v-else-if="option.value === 'PT'" :src="logoFlagPT" alt=""/>
              <img class="flag-nav" v-else :src="logoFlagEN" alt=""/>
              <span>{{ option.text }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-navbar-nav>
      </div>
    </div>
  </b-navbar>
</template>

<script>
import ProfileImage from './../../assets/static/images/image-profile2.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import FlagDEImage from './../../assets/static/images/de.png'
import FlagITImage from './../../assets/static/images/it.png'
import FlagESImage from './../../assets/static/images/es.png'
import FlagPTImage from './../../assets/static/images/pt.png'
import {loadPage, reloadPage2} from './../../helpers/routing'
import CompanyTheme from './../../helpers/companyTheme.json'
import Services from '@/helpers/services'
import conf from "@/config/config.dev";
import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence


/* Barre de navigation sur grands écran (ordinateurs), et liens contenus dans celle-ci */
export default {
  name: 'WebHeader',
  props: {
  },
  data () {
    return {
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      accountType: 0,
      companyId: 0,
      companyName: '',
      companyTheme: CompanyTheme,
      design: design.menu,
      language: '',
      languageLabel: 'Français',
      logoProfile: ProfileImage,
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoFlagDE: FlagDEImage,
      logoFlagIT: FlagITImage,
      logoFlagES: FlagESImage,
      logoFlagPT: FlagPTImage,
      menu: {},
      menuLinkList: null,
      options: [],
      resetMenu: false,
      selectedMenu: '',
      userName: '',
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.options = [
      { value: 'EN', text: this.$t('lang.english')},
      { value: 'FR', text: this.$t('lang.french')}
    ]
    this.menuLinkList = require('./data/menu.json')
    if (this.$engine.user.get().name != null) {
      this.companyName = this.$engine.user.get().name
    }
    this.getUsername()
    this.accountType = this.$engine.user.get().type
    this.companyId = this.$engine.user.get().id
    this.setMenuItems()
    this.$bus.$on('refresh-cache-menu', () => {
      this.companyName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
      this.setMenuItems()
    })
    let that = this
    this.$bus.$off('reset-selected-menu')
    this.$bus.$on('reset-selected-menu', function () {
      that.selectedMenu = ''
      let elem = document.getElementsByClassName('selectedMenuItemWebHeader').item(0)
      if (elem) {
        elem.classList.remove('selectedMenuItemWebHeader')
      }
      that.resetMenu = !that.resetMenu
    })
    this.$bus.$on('switch-selected-menu', function(newUrl) {
      that.selectedMenu = newUrl
    })
    if (this.$engine.auth.isAuth() && this.$f7.getCurrentView().url === '/login/') {
      this.selectedMenu = '/home/'
    } else {
      this.verifyCurrentView()
    }
    this.canUserSeePage()
  },
  mounted () {
  },
  computed: {
    hasRightHRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightHRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_hrtp') && right[1] === true) {
          rightHRTPFound = true
        }
      })
      return rightHRTPFound
    },
    hasRightSRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightSRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_srtp') && right[1] === true) {
          rightSRTPFound = true
        }
      })
      return rightSRTPFound
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    imgProfil () {
      return this.design.headbandProfilePic
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.options.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.language
      if (langOpt.length) {
        label = langOpt[0].text
      }
      return label
    }
  },
  methods: {
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    autoDropdown (value, id) {
      Object.keys(this.$refs).forEach((item) => {
        if (item === id) {
          if (this.$refs[item][0]) {
            this.$refs[item][0].visible = value
          } else {
            this.$refs[item].visible = value
          }
        }
      })
    },
    canShowSpecific (subItem) {
      if ((subItem.link === '/rights/profiles/') && this.$engine.user.get().type === '2') {
        return false
      }
      return true
    },
    canUserSeePage () {
      let currentPage = {}
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.selectedMenu) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.selectedMenu) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (Object.keys(currentPage).length === 0) {
        return
      }
    },
    getBackground () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].background) {
        return 'background: ' + this.companyTheme[this.companyId].background
      }
    },
    getClicked (subitem) {
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
          this.$engine.user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
          this.$engine.user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
              this.$engine.user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
              this.$engine.user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.VERIFICATIONS))
              this.$engine.user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      this.selectedMenu = subitem.link
      reloadPage2(that, subitem.link)
    },
    getLargeLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoLarge) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoLarge
      } else {
        return require('./../../assets/static/images/logo/dealprudence_white_green.png')
      }
    },
    getMiddleLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoMiddle) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoMiddle
      } else {
        return require('./../../assets/static/images/logo/mrlogo.png')
      }
    },
    getUsername () {
      let info = this.$engine.accounts.get()
      let userAccounts
      let userAccountId
      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUsername(userAccounts)
    },
    goToLink (linkToGo) {
      this.selectedMenu = linkToGo
      this.$f7.mainView.router.load({url: linkToGo, reload: true})
    },
    goToLoginPage () {
      var that = this
      loadPage(that, {url: '/login/'})
    },
    hasMultipleAccounts () {
      let accounts = this.$engine.accounts.get()
      let diffAccounts = []
      accounts.forEach(account => {
        if (!diffAccounts.includes(account.id)) {
          diffAccounts.push(account.id)
        }
      })
      return diffAccounts.length > 1
    },
    hasOneRight (itemList) {
      let that = this
      return itemList.filter(item => {
        return !that.isDisabledItem(item)
      }).length
    },
    isDisabledItem (item) {
      /* if (item && !item.enabled) {
        return true
      } */
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        if (item.right_disable.right === 'rights_profile_consult') {
          return this.$engine.user.get().id === this.$engine.user.get()
          ? this.$engine.rights.rightIs('rights_admin_consulter', item.right_disable.state)
          : this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        // Return true if the right has the same state as the disabling state
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    },
    isSubMenuActive (item) {
      let that = this
      return item.list.filter(elem => elem.link === that.selectedMenu).length
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      }
      else if (language === 'GB') {
        this.$i18n.locale = 'gb'
      }
      else if (language === 'ES') {
        this.$i18n.locale = 'es'
      }
      else if (language === 'IT') {
        this.$i18n.locale = 'it'
      }
      else if (language === 'DE') {
        this.$i18n.locale = 'de'
      }
      else if (language === 'PT') {
        this.$i18n.locale = 'pt'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.options = [
        { value: 'EN', text: this.$t('lang.english')},
        { value: 'FR', text: this.$t('lang.french')}
      ]
    },
    loadAccueil () {
      var that = this
      this.selectedMenu = '/home/'
      loadPage(that, {url: this.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
    },
    logout () {
      this.$bus.emit('logout')
    },
    setMenuItems () {
      this.menu = this.menuLinkList['linkContent']
      // compter le nombre de pages dispo
      let nbPage = 0
      let link = ''
      let that = this
      this.menu.forEach((item, index) => {
        if (item.list && item.list.length) {
          if (that.hasOneRight(item.list) && !that.isDisabledItem(item)) {
            item.list.forEach((subitem, subindex) => {
              if (subitem.enabled && that.canShowSpecific(subitem) && !that.isDisabledItem(subitem)) {
                nbPage++
                link = subitem.link
              }
            });
          }
        } else if (item.enabled && !that.isDisabledItem(item)) {
          nbPage++
          link = item.link
        }
      })
      if (nbPage === 1 ) {
        reloadPage2(that, link)
      }
    },
    updateUsername (userAccount) {
      this.userAccountInfo = userAccount
      this.userName = this.userAccountInfo[0].name
    },
    verifyCurrentView () {
      let pageExistsInMenu = false
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.$f7.getCurrentView().url) {
          pageExistsInMenu = true
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.$f7.getCurrentView().url) {
              pageExistsInMenu = true
              return
            }
          })
        }
      })
      if (pageExistsInMenu === true || this.$f7.getCurrentView().url === '/home/' || this.$f7.getCurrentView().url === '/profile/' || this.$f7.getCurrentView().url === '/settings/application/') {
        this.selectedMenu = this.$f7.getCurrentView().url
      } else {
        //Pour le cas des détails Dashboard par exemple DRO 02/08/2024
        this.selectedMenu = this.$f7.mainView.history[this.$f7.mainView.history.length - 2]
      }
    }
  }

}
</script>
